import { css, jsx } from '@emotion/core';
import { Col, Input, Row, Select } from 'antd';
import React from 'react';
import Form from '@/src/shared/components/Form';
import ReCaptchaFormItem from '@/src/shared/components/ReCaptchaFormItem';
import { selectProps } from '@/utils/formHelpers';
import { colMdProps, rowProps } from '@/utils/rowColHelpers';

const { Option } = Select;
const { TextArea } = Input;

const style = {
  text: css`
    font-size: 1.6rem;
    margin-bottom: 0px;
  `,
};
const alphabetizeSubjects = list => {
  const sortedList = list?.sort((a, b) => (a.type > b.type ? 1 : -1));
  return sortedList;
};
const FormFields = ({ data, form, name, defaultSubject = null }) => {

  return (
    <>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          <Form.Item label="Name">
            {form.getFieldDecorator('RequestorInformation', {
              initialValue: 'signedInUser',
              rules: [{ required: true, message: 'Name is required.' }],
            })(<p css={style.text}>{name}</p>)}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          <Form.Item label="Subject">
            {form.getFieldDecorator('TypeCode', {
              initialValue: defaultSubject,
              rules: [{ required: true, message: 'Select a Subject.' }],
            })(
              <Select {...selectProps(false)} placeholder="--Select a Subject--">
                {alphabetizeSubjects(data).map(d => (
                  <Option key={`${d.typeCode}`} value={d.typeCode}>
                    {d.type}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          <Form.Item label="Regarding">
            {form.getFieldDecorator('Subject', {
              rules: [{ required: true, message: 'Enter Regarding.' }],
            })(<Input allowClear size="large" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          <Form.Item label="Question/Comment">
            {form.getFieldDecorator('Question', {
              rules: [{ required: true, message: 'Enter Question/Comment.' }],
            })(<TextArea rows={4} allowClear />)}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowProps}>
        <Col {...colMdProps}>
          <Form.Item label="">
            {form.getFieldDecorator('ReCaptcha', {
              rules: [{ required: true, message: 'Check, checkbox.' }],
            })(<ReCaptchaFormItem />)}
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

FormFields.propTypes = {};

export default FormFields;
